import $api from "../http/index";
import { ProductsResponse } from "../models/response/ProductsResponse";
import { TransferResponse } from "../models/response/TransferResponse";
import { KitsResponse } from "../models/response/KitsResponse";
import { DepositBonuses_Response } from "../models/response/DepositBonuses_Response";
import { AxiosResponse } from 'axios';

export default class ShopService {
    static async getDepositBonuses(): Promise<AxiosResponse<DepositBonuses_Response[]>> {
        return $api.get<DepositBonuses_Response[]>('/shop/deposit/bonuses');
    }
    static async getKits(): Promise<AxiosResponse<KitsResponse[]>> {
        return $api.get<KitsResponse[]>('/shop/kits');
    }
    static async getProducts(): Promise<AxiosResponse<ProductsResponse[]>> {
        return $api.get<ProductsResponse[]>('/shop/products');
    }
    static async buyProduct(item:any): Promise<AxiosResponse<TransferResponse>> {
        return $api.post<TransferResponse>('/shop/buy', {item});
    }
}